import { Search_Sort_Types, Sort_Direction } from '../generated/graphql'

interface SortTypeMap {
    [key: string]: Search_Sort_Types
}

const sortTypeMap: SortTypeMap = {
    date: Search_Sort_Types.IfOfferCreatedDate,
    saleDate: Search_Sort_Types.SaleDateLastRanTime,
    buyerAgent: Search_Sort_Types.BuyerAgent,
    buyerAccount: Search_Sort_Types.BuyerAccount,
    sellerAccount: Search_Sort_Types.SellerAccount,
    soldDate: Search_Sort_Types.SoldDateLastRanTime,
    run: Search_Sort_Types.RunNumber,
    yearMakeModel: Search_Sort_Types.YearMakeModel,
    makeModelYear: Search_Sort_Types.MakeModelYear,
    daysOnLot: Search_Sort_Types.DaysOnLot,
}

// List Sorting Type Function
export const sortingTypeConfig = (sortTypeString?: string): Search_Sort_Types | undefined => {
    const sortTypeNoSign = sortTypeString?.replace(/^\+|-/, '') || ''

    return sortTypeMap[sortTypeNoSign]
}

// List Sorting Order Function
export const sortingOrderConfig = (sortOrderString?: string): Sort_Direction | undefined => {
    let sortOrderEnum
    const sortDescending = sortOrderString?.startsWith('-')

    if (sortDescending) {
        sortOrderEnum = Sort_Direction.Desc
    } else {
        sortOrderEnum = Sort_Direction.Asc
    }
    return sortOrderEnum
}

// TODO: aggregate sort
// export const aggrSortConfig = () => undefined
